export default [
    {
        "value": "Doutor",
        "text": "Doutor"
    },
    {
        "value": "Mestre",
        "text": "Mestre"
    },
    {
        "value": "Especialista",
        "text": "Especialista"
    },
    {
        "value": "Superior",
        "text": "Superior"
    },
    {
        "value": "Tecnico",
        "text": "Técnico"
    }
]